import {
  Component,
  EventEmitter,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { AccountService } from '../../../models/account/accountService';
import { AccountDetailsFormComponent } from '../account-details-form/account-details-form.component';
import { Account } from '../../../models/account/account';
import { User } from '../../../models/users/user';
import { FormMode } from '../../../core/constants';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import {
  TextInputComponent,
  TextModes,
} from '../../ui/controls/text-input/text-input.component';
import { DdlInputComponent } from '../../ui/controls/ddl-input/ddl-input.component';
import { SiteDataService } from '../../../models/ui/siteDataService';

@Component({
  selector: 'app-account-onboard',
  templateUrl: './account-onboard.component.html',
  standalone: false,
})
export class AccountOnboardComponent {
  @ViewChild(AccountDetailsFormComponent, { static: true })
  accountForm: AccountDetailsFormComponent;
  @Output() newAccountId = new EventEmitter<string | undefined>();

  @ViewChildren(TextInputComponent) validatedTextBoxes:
    | QueryList<TextInputComponent>
    | undefined;
  @ViewChildren(DdlInputComponent) validatedDropDowns:
    | QueryList<DdlInputComponent>
    | undefined;

  _user: Partial<User> = User.createEmpty();
  _chkUserSameAsContact: boolean = false;

  _onboardFormMode: FormMode = FormMode.Edit;
  InputTextModesEnum = TextModes;

  public get formMode(): typeof FormMode {
    return FormMode;
  }

  constructor(
    private accountService: AccountService,
    private siteDataService: SiteDataService,
    private uiErrorHandler: UIErrorHandler,
  ) {
    this.accountForm = new AccountDetailsFormComponent(
      this.siteDataService,
      this.uiErrorHandler,
      accountService,
    ); // required by Typescript
  }

  btnCancel_click() {
    this.newAccountId.emit(undefined);
  }

  chkUserSameAsContact_clicked() {
    if (this._chkUserSameAsContact) {
      let account: Account = this.accountForm.getAccountInfo();

      if (account.owner) {
        this._user.firstName = account.owner.firstName;
        this._user.lastName = account.owner.lastName;
        this._user.emailAddress = account.owner.emailAddress;
      } else {
        this._user.firstName = '';
        this._user.lastName = '';
        this._user.emailAddress = '';
      }
    } else {
      this._user.firstName = '';
      this._user.lastName = '';
      this._user.emailAddress = '';
    }
  }

  txtEmail_keyup() {
    // if email contains /xxxxx@x/:
    // do global user search by email
  }

  btnSave_click() {
    let errors = this.uiErrorHandler.gatherFormErrors(
      true,
      this.accountForm.getValidatedControls(),
      this.validatedTextBoxes?.toArray(),
      this.validatedDropDowns?.toArray(),
    );

    if (errors.length == 0) {
      let account: Account = this.accountForm.getAccountInfo();
      account.primaryUser = this._user;

      if (account != undefined && account.owner != undefined) {
        this.accountService
          .createAccount(
            account.accountName,
            account.owner,
            account.primaryUser,
          )
          .then((id) => {
            this.accountForm.clearForm();
            this.newAccountId.emit(id);
          })
          .catch((message) => {
            this.uiErrorHandler.handleError(message);
          });
      }
    }
  }
}
